module.exports = __webpack_public_path__ + "static/media/error-image.275bb24e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error-image.png
// module id = 664
// module chunks = 0